<template>
    <div>
      <div v-if="!getTheNodeConfig">
        <h2>{{ formTitle | upper }}</h2>
        <el-form ref="form" :model="form" label-width="120px" :label-position="'top'" >

          <el-row>
            <el-col :lg="12" :xl="12">
              <el-form-item :label="$t('production_area_name')">
                <el-input placeholder="Nom" v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="12" :xl="12">
              <el-form-item :label="$t('associated_node_id')">
                <el-input placeholder="id" v-model="form.nodeId"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :lg="12" :xl="12">
              <el-form-item :label="$t('description')">
                <el-input type="textarea" placeholder="description" v-model="form.description"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="form-row-margin">
            <el-col :lg="12">
              <el-tag
                :key="tag"
                v-for="tag in form.tags"
                closable
                :disable-transitions="false"
                @close="handleCloseTag(tag)">
                {{tag}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="tagInputVisible"
                v-model="tagInputValue"
                ref="saveTagInput"
                size="mini"
                @keyup.enter.native="handleInputConfirmTag"
                @blur="handleInputConfirmTag"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInputTag">+ {{ $t('add_tag') }}</el-button>
            </el-col>
          </el-row>
          


          <div v-if="isSuperAdmin">
            <h2>Node configuration file</h2>
            <el-divider></el-divider>
            <el-row :gutter="48">
              <el-col :lg="8" :xl="8">
                <el-form-item :label="$t('node_conf_id')">
                  <el-input placeholder="id" v-model="form.nodeInfo.id"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :xl="8">
                <el-form-item :label="$t('node_conf_channel')">
                  <el-input placeholder="Channel" v-model="form.nodeInfo.channel"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :xl="8">
                <el-form-item :label="$t('node_conf_frequency')">
                  <el-input placeholder="frequency" v-model="form.nodeInfo.frequency"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item :label="$t('node_conf_uuid')">
                <el-input placeholder="abc-123-ert, zdrt-78hjfi-jsij-45" v-model="uuidStr"></el-input>
              </el-form-item>
            </el-row>

            <el-row :gutter="48">
              <el-col :lg="12" :xl="12">
                <el-form-item :label="$t('node_conf_ip')">
                  <el-input placeholder="ip" v-model="form.nodeInfo.ip"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :xl="12">
                <el-form-item :label="$t('node_conf_ip_gw')">
                  <el-input placeholder="ip_gw" v-model="form.nodeInfo.ip_gw"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="48">
              <el-col :lg="12" :xl="12">
                <el-form-item :label="$t('node_conf_gw_if')">
                  <el-input placeholder="gw_if" v-model="form.nodeInfo.gw_if"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :xl="12">
                <el-form-item :label="$t('node_conf_nw_name')">
                  <el-input placeholder="nw_name" v-model="form.nodeInfo.nw_name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          
            <el-row :gutter="48">
              <el-col :lg="12" :xl="12">
                <el-form-item :label="$t('node_conf_api_key')">
                  <el-input placeholder="API key" v-model="form.nodeInfo.apikey"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :xl="12">
                <el-form-item :label="$t('node_conf_password')">
                  <el-input placeholder="password" v-model="form.nodeInfo.password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <RpiConfigForm></RpiConfigForm> -->
          </div>

          <el-row>
            <el-form-item>
              <el-button type="success" @click="createForm">{{ formState | upper}} {{ $t('production_area') }}</el-button>
              <el-button @click="initFormAndClose">{{ $t('cancel') }}</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </div>

      <div v-else>
        <h2>The Node config file</h2>
        <p>Dowload the node config file generated</p>
        <el-button>
          <a :href="`data:${configurationNode}`" download="configurationNode.json">download</a>
        </el-button>
      </div>

    </div>
</template>

<script>
//-- WIP (no axios or store)

import { operatorsTable, piReceptorTable, opFabTable } from '../../data/dynamoDBSimulation.js'; //-- Simulate Data from DynamoDB
import CleanObject from '../../mixins/CleanObject';
import DateTimeManipulation from '../../mixins/DateTimeManipulation';

export default {
  props: {
    formStateModal: {
      type: String,
    },
    itemSelected: {
      type: Object
    },
    formTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isSuperAdmin: false,
      operatorsList: [],
      piReceptorList: [],
      checkboxMachines: [],
      formState: 'create',
      tagInputVisible: false,
      tagInputValue: '',
      uuidStr: '',
      getTheNodeConfig: false,
      configurationNode: {},
      form: {
        id:'',
        nodeId: '',
        description: '',
        name: '',
        tags: [],
        nodeInfo: {
          id: '',
          uuids: [],
          channel: -1,
          frequency: 2432,
          ip: '172.27.0.2/24',
          ip_gw: '172.27.0.1',
          gw_if: 'eth0',
          nw_name: '\u0008',
          password: 'hello',
          apikey: 'RandomApiKey',
          apiurl: 'NoValidUrl'
        }
      }
    }
  },
  created () {
    this.operatorsList = this.dataToTransfert(operatorsTable, ['operator_id', 'firstName', 'lastName']);
    this.piReceptorList = this.dataToTransfert(piReceptorTable, ['id', 'name']);
    if(this.formStateModal !== undefined) {
      this.formState = this.formStateModal;
    } else {
      this.setFormState(this.$route.name);
    }
    if(this.itemSelected !== undefined) {
      this.setForm(this.itemSelected);
      this.uuidStr = this.arrayToUuidStr(this.itemSelected.nodeInfo.uuids);
    } else if(this.formState === 'edit' || this.formState === 'duplicate') {
      //-- Fetch OF with id form.of_if
      let selectedOf = opFabTable.find( elmt => elmt.id === this.form.id );
      this.setForm(selectedOf);
      this.uuidStr = this.arrayToUuidStr(this.selectedOf.nodeInfo.uuids);
    }
    this.isSuperAdmin = this.$store.getters.isSuperAdmin;
  },
  watch: {
    configurationNode(nval) {
      if(nval !== undefined) {
        let element = document.createElement('a');
        element.setAttribute('href',`data:${this.configurationNode}`);
        element.setAttribute('download', "configurationNode.json");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    }
  },
  methods: {
    dataToTransfert: function(collection, keyList) {
      let data = []
      if(collection !== undefined) {
        collection.forEach( dt => {
          let objToData = {};
          objToData.key = dt[keyList[0]];
          objToData.label = `${dt[keyList[1]]} ${dt[keyList[2]] !== undefined ? dt[keyList[2]]: ''}`;
          objToData.disabled = false;
          data.push(objToData);
        });
      }
      return data;
    },
    getMachineIdInsteadOfName: function(machineSelectedList, piReceptorList) {
      let machinesId = [];
      if(machineSelectedList !== undefined) {
        machineSelectedList.forEach( name => {
          const founded = piReceptorList.find( obj => obj.name === name);
          machinesId.push(founded.id);
        })
      }
      return machinesId;
    },
    getMachineNameInsteadOfId: function(machineSelectedList, piReceptorList) {
      let machinesName = [];
      if(machineSelectedList !== undefined) {
        machineSelectedList.forEach( id => {
          const founded = piReceptorList.find( obj => obj.id === id);
          machinesName.push(founded.name);
        })
      }
      return machinesName;
    },
    setFormState: function(routeName) {
      if(routeName.includes('create')) {
        this.formState = 'create';
      } else if(routeName.includes('duplicate')) {
        this.formState = 'duplicate';
        this.form.id = this.$route.params.id;
      } else if(routeName.includes('edit')) {
        this.formState = 'edit';
        this.form.id = this.$route.params.id;
      }
    },
    handleCloseTag(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    showInputTag() {
      this.tagInputVisible = true;
      this.$nextTick( () => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirmTag() {
      let inputValue = this.tagInputValue;
      if (inputValue) {
        this.form.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    setForm: function(data) {
      const kv = Object.entries(data);
      for (const [k, v] of kv) {
        this.form[k] = v;
      }
    },
    initForm: function() {
      this.form = {
       id:'',
        nodeId: '',
        name: '',
        description: '',
        tags: [],
        nodeInfo: {
          id: '',
          uuids: [],
          channel: -1,
          frequency: 2432,
          ip: '172.27.0.2/24',
          ip_gw: '172.27.0.1',
          gw_if: 'eth0',
          nw_name: '\u0008',
          password: 'hello',
          apikey: 'RandomApiKey',
          apiurl: 'NoValidUrl'
        }
      },
      this.checkboxMachines = [];
    },
    initFormAndClose: function() {
      this.initForm();
      this.$emit('closeForm', false);
    },
    createForm: function() {

      let cleanedForm = this.cleanObject(this.form);
      if(this.uuidStr !== '') {
        cleanedForm.nodeInfo.uuids = this.uuidStrToArray(this.uuidStr);
      }
      if(this.formState === 'create' || this.formState === 'duplicate') {
        this.$store.dispatch('postProductionZones', cleanedForm)
        .then( res => {
          this.$message({
            message: res.message,
            type: res.type
          });
          if((res.status === 200 || res.status === 201) && res.configurationNode !== undefined) {
            this.configurationNode = `text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(res.configurationNode))}`;
            this.getTheNodeConfig = true;
          }
        })
      }
      if(this.formState === 'edit') {
        cleanedForm.id = this.itemSelected.id
        this.$store.dispatch('editProductionZone', cleanedForm)
        .then( res => {
          this.$message({
            message: res.message,
            type: res.type
          });
          res.status === 200 ? this.initForm() : '';
        })
      }
    },
    uuidStrToArray(uuid) {
      let uuidArr = uuid.split(',');
      return uuidArr.map( item => item.trim());
    },
    arrayToUuidStr(arr) {
      return arr.join(', ');
    }
  },
  mixins: [CleanObject, DateTimeManipulation]
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .form-row-margin {
    margin-bottom: 24px;
  }
</style>